module.exports = __webpack_public_path__ + "img/s-polygon.c07e57da.svg";